export default function AboutSection() {
  return (
    <section id="about" className="w-full py-20 md:py-28 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-100 mb-6">
          关于爆料专区
        </h2>
        <div className="w-16 h-1 bg-primary-500 mx-auto mb-8 rounded-full"></div>
        <p className="text-foreground-300 text-sm md:text-base leading-relaxed max-w-3xl mx-auto">
          爆料专区是一个聚焦网红明星争议事件的深度内容平台。我们不生产八卦——
          我们挖掘被掩盖的黑料内幕，还原被粉饰的黑料真相。
          从顶流明星的塌房实录到头部网红的翻车现场，从综艺选秀的暗箱操作到品牌代言的虚假宣传，
          爆料专区以多信源交叉验证的方式，为你呈现娱乐圈和网红圈最不为人知的负面猛料。
          平台坚持匿名投稿机制，保护每一位爆料人的隐私安全，让真相不被资本和流量掩埋。
        </p>
      </div>
    </section>
  );
}